import React from 'react';
import Navbar from '../components/Navbar';
import './ProtectedPage.css';

const MyAppsPage = () => {
    return (
        <div className="protected-page">
            <Navbar />
            <div className="page-content">
                <div className="page-header">
                    <h1 className="page-title">My Apps</h1>
                    <p className="page-subtitle">Manage your registered applications & API keys</p>
                </div>

                <div className="page-card">
                    <div style={{ textAlign: 'center', padding: '3rem' }}>
                        <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🚀</div>
                        <h3 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>No Apps Created Yet</h3>
                        <p style={{ color: '#94a3b8', marginBottom: '2rem' }}>
                            Get started by creating your first application to generate API keys.
                        </p>
                        <button className="cta-button primary" style={{ cursor: 'pointer' }}>
                            Create New App
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MyAppsPage;
